import { fetchList } from 'share/services/api'
import { isAdmin } from 'services/policy'
import HasManyMapper from 'share/services/mappers/has-many'
const workflowsMapper = new HasManyMapper('workflows', '$workflows');

const config = { page: 1, per_page: 3 };

export default () => ({
  get() {
    const allowUsers = document.querySelector('[data-allow-users="1"]');
    const allowUserGroups = document.querySelector('[data-allow-user-groups="1"]');
    const allowOncallGroups = document.querySelector('[data-allow-oncall-groups="1"]');
    const allowVisitors = document.querySelector('[data-allow-visitors="1"]');
    const isCurrentUserDelegated = document.querySelector('[data-curent-user-is-delegated="1"]')

    let promises = [];
    if (allowUsers) {
      promises.push(fetchList('/users', 'users', config).then(users => 
        // Filter out users with GSU and GSA roles
        users.filter(user => !['GSU', 'GSA'].includes(user.roleId))
      ));
    } else {
      promises.push(Promise.resolve([]));
    }

    if (allowUserGroups) {
      if (isAdmin() || !isCurrentUserDelegated) {
        promises.push(
          fetchList('/user_groups', 'user_groups', config)
            .then(userGroups =>
              workflowsMapper.mapCounts(userGroups).then(() => userGroups)
            )
        );
      } else {
        promises.push(
          fetchList('/user_groups?delegated_to=' + gon.app.user.id, 'user_groups', {})
            .then(userGroups =>
              workflowsMapper.mapCounts(userGroups).then(() => userGroups)
            )
        );
      }
    } else {
      promises.push(Promise.resolve([]));
    }

    if (allowOncallGroups) {
      promises.push(
        fetchList('/oncall_groups', 'oncall_groups', config)
          .then(oncallGroups =>
            workflowsMapper.mapCounts(oncallGroups).then(() => oncallGroups)
          )
      );
    } else {
      promises.push(Promise.resolve([]));
    }

    if (allowVisitors) {
      promises.push(fetchList('/visitors', 'visitors', config));
    } else {
      promises.push(Promise.resolve([]));
    }

    return Promise.all(promises).then(([users, userGroups, oncallGroups, visitors]) => ({
      users,
      userGroups,
      oncallGroups,
      visitors
    }));
  }
})
